import Category from '@shared/classes/category';
import FilterButton from '@components/elements/buttons/filterButton';
import FilterContainer from '@components/atoms/container/channelFilterContainer';
import FilterSearch from '@components/elements/filter/channelFilterSearch';
import FilterTitle from '@components/elements/filter/channelFilterTitle';
import List from '../../list';
import MainContext from '@shared/components/utils/context/mainContext';
import Pages from '@pages';
import RailProps from '../../../../../../shared/types/props/rail';
import { pushRoute } from '@shared/store/thunks/route.thunk';
import { store } from '@shared/store/store';
import { useCallback, useContext } from 'react';
import { useAppSelector } from '@shared/store/hooks';
import { routerSelector } from '@shared/store/slices/router.slice';

export default function FilterRail({ list }: RailProps) {
  const { filter, setFilter } = useContext(MainContext);
  const { route } = useAppSelector(routerSelector);

  const hideSearch = route.Page === Pages.CLASSIC_CHANNEL;

  // Event handlers

  const filterAction = useCallback((item: Category) => {
    setFilter(item?.id ? item : undefined);
  }, []);

  const searchAction = useCallback(() => {
    store.dispatch(
      pushRoute({
        route: { Page: Pages.SEARCH },
        params: {
          push: true,
        },
      })
    );
  }, []);

  // Components

  // Map the list data to filter buttons
  const ListComponents = [
    ...(list.data as (Category | undefined)[]).map(
      (item: Category | undefined, index: number) => {
        if (!item) return;
        const buttonIndex = hideSearch ? index : index + 1;
        return (
          <FilterButton
            key={`filter-button-${buttonIndex}`}
            active={filter === item || (!item.id && !filter)}
            index={buttonIndex}
            text={item.title}
            onFocus={() => filterAction(item)}
          />
        );
      }
    ),
  ];

  // Add search component if search is not hidden on the current page
  if (!hideSearch) {
    ListComponents.unshift(
      <FilterSearch
        key={0}
        index={0}
        action={searchAction}
        hideSearch={hideSearch}
      />
    );
  }

  // Render the filter container
  return (
    <FilterContainer>
      {hideSearch ? <FilterTitle /> : null}
      {list?.data?.length ? <List {...list}>{ListComponents}</List> : null}
    </FilterContainer>
  );
}
